import React from 'react';
import Card from '@mui/material/Card';
import TutoringV2Tab from './tutoringV2Tabs/TutoringV2Tab';

function TutoringV2Component() {
  return (
    <Card>
      <TutoringV2Tab />
    </Card>
  );
}

export default TutoringV2Component;
